import { React, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import AnimateHeight from "react-animate-height";
import ButtonIcon from "components/utility/button/ButtonIcon";

const AccordionDrawer = (props) => {
	const [isExpanded, setIsExpanded] = useState(true);
	const { title, subtitle } = props.data;
	const {
		expandOverrideStatus,
		expandOverrideControl,
		uid,
		animDuration,
		isDrawerToggleable = true
	} = props;
	const previousValue = useRef(expandOverrideStatus).current;
	const drawerContentId = "drawer-content-" + uid;
	const onClickExpand = expandOverrideControl
		? () => expandOverrideControl()
		: () => setIsExpanded(!isExpanded);

	useEffect(() => {
		if (previousValue.expandOverrideStatus !== expandOverrideStatus) {
			setIsExpanded(expandOverrideStatus);
		}
	}, [previousValue, expandOverrideStatus]);

	const expandedStatus = expandOverrideControl ? expandOverrideStatus : isExpanded;
	return (
		<div className={"accordion-drawer accordion-drawer" + (expandedStatus ? "--open" : "--closed")}>
			<div
				id={"drawer-header-" + uid}
				className="accordion-drawer-header"
				aria-expanded={expandedStatus ? "true" : "false"}
				aria-owns={drawerContentId}
			>
				<ButtonIcon
					type="toggle"
					onClick={isDrawerToggleable ? () => onClickExpand() : null}
					onKeyPress={() => null} // override keypress to avoid double events
					className={expandedStatus ? "open" : "closed"}
					ariaLabel={"toggle drawer"}
					ariaExpanded={expandedStatus ? "true" : "false"}
					ariaControls={drawerContentId}
					tabIndex="0"
				/>
				<button
					className="drawer-title"
					onClick={isDrawerToggleable ? () => onClickExpand() : null}
					tabIndex="0"
					dangerouslySetInnerHTML={{ __html: title }}
				></button>
				{subtitle ? <div className="drawer-subtitle">{subtitle}</div> : null}
			</div>
			<AnimateHeight
				id={drawerContentId}
				className="accordion-drawer-content"
				height={expandedStatus ? "auto" : 0}
				duration={animDuration >= 0 ? animDuration : 200}
			>
				{props.children}
			</AnimateHeight>
		</div>
	);
};

AccordionDrawer.propTypes = {
	animDuration: PropTypes.number,
	expandOverrideStatus: PropTypes.bool,
	expandOverrideControl: PropTypes.func,
	data: PropTypes.shape({
		title: PropTypes.string,
		subtitle: PropTypes.string
	}),
	isDrawerToggleable: PropTypes.bool,
	uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

AccordionDrawer.defaultProps = {
	expandOverrideStatus: false,
	isDrawerToggleable: true,
	uid: 0
};

export default AccordionDrawer;
